import React from "react";

interface InputNumberProps {
  value: string | number | undefined;
  onChange: any;
  label: string;
  placeholder?: string;
  step?: number | string
}

const InputNumber = ({
  value,
  onChange,
  label,
  placeholder,
  step
}: InputNumberProps) => {
  return (
    <label className="flex flex-col flex-grow max-w-full">
      <p className={placeholder && "sr-only"}>{label}</p>
      <input
        className="bg-black/20 border-b p-2 focus:outline-none focus:ring-yellow-200/60 focus:ring-2 focus:ring-inset focus:border-yellow-200/60"
        type="number"
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder || ""}
        step={step || 1}
      />
    </label>
  );
};

export default InputNumber;
